import BaseCrudService from "./baseCrud.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";

export default class UserSSOService extends BaseCrudService {

    constructor() {
        super('UserSSO');
    }

    save(userSSO){
        return this.postRequest('Save', userSSO);
    }

    findByDocument(document){
        return this.postRequest('FindByDocument', document);
    }
}